import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { UnauthenticatedHomepage } from '../pages/Homepage/Unauthenticated'
import Solopreneur from '../pages/Homepage/Solopreneur'
import BusinessHomepage from '../pages/Homepage/Business'
import AboutUs from '../pages/About/AboutUs'
import { PlansPage } from '../pages/Plans/Plans'
import Blog from '../pages/Blog/Blog'
import BlogView from '../pages/Blog/BlogView'
import { WebsiteError404 } from '../pages/Errors/404'

function skipAppRoutes(Component) {
    return ({ location, ...props }) => {
        if (/^(?!\/app).*$/g.test(location.pathname)) {
            return <Component location={location} {...props} />
        } else {
            return null
        }
    }
}

const WebsiteRoutes = () => {
    return (
        <Switch>
            <Route
                path={'/'}
                component={UnauthenticatedHomepage}
                exact={true}
            />
            <Route path={'/business'} component={BusinessHomepage} exact />
            <Route path={'/about-us'} component={AboutUs} />
            <Route path={'/solo-preneur'} component={Solopreneur} />
            <Route path={'/plans'} component={PlansPage} />
            <Route path={'/blog'} exact component={Blog} />
            <Route path={'/blog/:postId'} component={BlogView} />
            <Route render={skipAppRoutes(WebsiteError404)} />
        </Switch>
    )
}

export default WebsiteRoutes
